import "./styles.css";

import React, {useState} from "react";

import { LottieScrollSection } from "react-lottie-tools";
import animationData from "./static/data.json";

import { useEffect } from 'react';
import '@n8n/chat/style.css';
import { createChat } from '@n8n/chat';


const defaultValues = {
  companyName: "",
  clientName: "",
  data: animationData,
  clients: [] as {client: any, playScript: string}[],
  isRender: true
};

export const N8NChat = () => {
  useEffect(() => {
    createChat({
      webhookUrl: 'https://vmotion.app.n8n.cloud/webhook/1727c687-aed0-49cf-96af-e7796819fbb3/chat',
      webhookConfig: {
        method: 'POST',
        headers: {}
      },
      // target: '#n8n-chat',
      mode: 'window',
      // chatInputKey: 'chatInput',
      chatSessionKey: 'sessionId',
      metadata: {},
      showWelcomeScreen: false,
      defaultLanguage: 'en',
      initialMessages: [
      ],
      i18n: {
        en: {
          title: 'Hi there! 👋',
          subtitle: "My name is HEALTH WAVE AI",
          footer: '',
          getStarted: 'New Conversation',
          inputPlaceholder: 'Type your question..',
          closeButtonTooltip: ""
        },
      },
    });
  }, []);

  return (<div></div>);
};

const LottieControl = () => {
  const [formValues, setFormValues] = useState(defaultValues);
  const [, updateState] = React.useState();
  const forceUpdate = React.useCallback(() => updateState({} as any), []);

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
      isRender: false
    });
  };

  const prepareData = (animationData: any, mapping: any, client: any) => {
    const animationDataString = JSON.stringify(animationData);

    const keys = Object.keys(mapping);
    const clientAnimationString = keys.reduce((accumulator, currentValue) => {
      return accumulator.replaceAll(mapping[currentValue], client[currentValue])
    }, animationDataString);

    return JSON.parse(clientAnimationString);
  }

  const openPowerBi = (powerBiLink: string) => {
    window.open(powerBiLink, "_blank");
  };

  return (
      <div>
        <div>
          <LottieScrollSection className="slide" height={4000} animation={formValues.data} frames={[5, 239]} />
          <LottieScrollSection className="slide" height={4000} animation={formValues.data} frames={[245, 510]} />
          <LottieScrollSection className="slide" height={4000} animation={formValues.data} frames={[520, 730]} />
          <LottieScrollSection className="slide" height={4000} animation={formValues.data} frames={[770, 960]} />
          <LottieScrollSection className="slide" height={4000} animation={formValues.data} frames={[970, 1220]} />
          <LottieScrollSection className="slide" height={4000} animation={formValues.data} frames={[1230, 1405]} />
          <LottieScrollSection className="slide" height={4000} animation={formValues.data} frames={[1410, 1670]} />
          <LottieScrollSection className="slide" height={4000} animation={formValues.data} frames={[1675, 1915]} />
          <LottieScrollSection className="slide" height={4000} animation={formValues.data} frames={[1920, 2180]} />
          <LottieScrollSection className="slide" height={4000} animation={formValues.data} frames={[2185, 2360]} />
          <LottieScrollSection className="slide" height={4000} animation={formValues.data} frames={[2375, 2630]} />
          <LottieScrollSection className="slide" height={4000} animation={formValues.data} frames={[2635, 2800]} />
          <LottieScrollSection className="slide" height={4000} animation={formValues.data} frames={[2815, 3065]} />
          <LottieScrollSection className="slide" height={4000} animation={formValues.data} frames={[3070, 3250]} />
          <LottieScrollSection className="slide" height={4000} animation={formValues.data} frames={[3255, 3500]} />
        </div>
        <N8NChat></N8NChat>
      </div>
  );
};

export default LottieControl;
